import {IToJson} from '@toolify/client/src/types/IToJson'
import {IDeploymentVersionResponseInstance} from '@toolify/server/src/adapters/InstanceApiResponseAdapter/types/responseInstances/IDeploymentVersionResponseInstance'
import {mapDeploymentVersionItemResponseInstance} from './mapDeploymentVersionItemResponseInstance'

export function mapDeploymentVersionResponseInstance(
  deploymentVersion: IToJson<IDeploymentVersionResponseInstance>,
): IDeploymentVersionResponseInstance {
  return {
    ...deploymentVersion,
    publishedAt: deploymentVersion.publishedAt,
    deploymentVersionItems: deploymentVersion.deploymentVersionItems?.map(item => mapDeploymentVersionItemResponseInstance(item)) || null,
  }
}
